import { captureStack1fzi4aczwc4hg as captureStack } from '../../js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_coroutines_cancellation_CancellationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.id_1);
}
var CancellationExceptionClass;
function CancellationException() {
  if (CancellationExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static jd() {
        var $this = this.kd();
        init_kotlin_coroutines_cancellation_CancellationException($this);
        return $this;
      }
      static ld(message) {
        var $this = this.o4(message);
        init_kotlin_coroutines_cancellation_CancellationException($this);
        return $this;
      }
      static md(message, cause) {
        var $this = this.nd(message, cause);
        init_kotlin_coroutines_cancellation_CancellationException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'CancellationException', $.jd);
    CancellationExceptionClass = $;
  }
  return CancellationExceptionClass;
}
//region block: exports
export {
  CancellationException as CancellationException3b36o9qz53rgr,
};
//endregion

//# sourceMappingURL=CancellationException.mjs.map
